import React from "react";

export default function StatCard({ icon: Icon, label, value, sub, testId, accent = false }) {
  return (
    <div className="neu-card p-6 flex items-start justify-between gap-3" data-testid={testId}>
      <div>
        <div className="text-sm subtle uppercase tracking-wider font-medium">{label}</div>
        <div className={`mt-3 heading text-3xl md:text-4xl ${accent ? "text-neu-accent" : ""}`}>
          {value}
        </div>
        {sub && <div className="text-xs subtle mt-2">{sub}</div>}
      </div>
      <div className="w-11 h-11 rounded-xl bg-neu-bg flex items-center justify-center shadow-neu-inset-sm">
        {Icon && <Icon className="w-5 h-5 text-neu-accent" />}
      </div>
    </div>
  );
}
